import type { RunnerLicense } from "@/lib/api";
import { formatJstDate, formatJstMonthDay } from "@/lib/billing";

/** デバイスの一覧の「ライセンス」の列。次の更新日・解約の予定 (更新日に解除)・支払い待ちを出す。 */
export function RunnerLicenseCell({ id, license }: { id: string; license: RunnerLicense | null }) {
	if (license === null)
		return (
			<span data-testid={`runner-license-${id}`} style={{ color: "var(--fg-3)" }}>
				—
			</span>
		);
	return (
		<div data-testid={`runner-license-${id}`}>
			{license.cancelRequestedAt === null ? (
				<div style={{ fontVariantNumeric: "tabular-nums" }}>
					次の更新日 {formatJstDate(license.renewsAt)}
				</div>
			) : (
				<div style={{ color: "var(--warning)" }}>
					更新日 ({formatJstMonthDay(license.renewsAt)}) に解除
				</div>
			)}
			{license.unpaidSince !== null && (
				<div style={{ color: "var(--danger)", marginTop: 2 }}>
					支払い待ち ({formatJstMonthDay(license.unpaidSince)} から)
				</div>
			)}
		</div>
	);
}
